<div class="app-shell">
  <p-toast />
  <router-outlet />

  @if (pwaInstallPrompt.visible()) {
    <section
      class="pwa-install-banner"
      aria-labelledby="pwa-install-title"
      aria-describedby="pwa-install-description"
    >
      <div class="pwa-install-copy">
        <p class="pwa-install-eyebrow">App no celular</p>
        <h2 id="pwa-install-title">{{ pwaInstallPrompt.title() }}</h2>
        <p id="pwa-install-description">{{ pwaInstallPrompt.description() }}</p>
      </div>

      <div class="pwa-install-actions">
        @if (pwaInstallPrompt.canInstall()) {
          <button type="button" class="pwa-install-primary" (click)="installPwa()">Instalar</button>
        }

        <button type="button" class="pwa-install-secondary" (click)="dismissPwaInstallPrompt()">
          Entendi
        </button>
      </div>
    </section>
  }
</div>
